// extracted by mini-css-extract-plugin
module.exports = {"msgWrap":"Preview_msgWrap__y0F9R","msgPrimary":"Preview_msgPrimary__My_uK","msgSecondary":"Preview_msgSecondary__1MQZa","icon":"Preview_icon__28bzc"};